import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import lottie from 'lottie-web';
import Container from './Container';

const Animation = ({ data, options, ...props }) => {
  const container = useRef();

  useEffect(() => {
    const animation = lottie.loadAnimation({
      container: container.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      ...options,
      animationData: data,
    });
    return () => {
      animation.destroy();
    };
  }, [data, options]);

  return <Container ref={container} {...props} />;
};

Animation.propTypes = {
  data: PropTypes.shape({}).isRequired,
  options: PropTypes.shape({}),
};

Animation.defaultProps = {
  options: null,
};

export default Animation;
